import { useTranslation } from 'react-i18next'

import { AcknowledgeModal, Modal } from '@percent/lemonade'
import type { UseModalReturn } from '@percent/domain/giving'

export type PublishCampaignSuccessModalProps = Pick<UseModalReturn, 'isOpen' | 'closeModal'>

export function PublishCampaignSuccessModal({ isOpen, closeModal }: PublishCampaignSuccessModalProps) {
  const { t } = useTranslation()

  return (
    <Modal open={isOpen} onClose={closeModal} aria-labelledby="publish-campaign-success">
      <AcknowledgeModal
        result="positive"
        title={t('workplace_giving.myCampaigns.actions.publishSuccessModal.title')}
        buttonText={t('workplace_giving.common.close')}
        handleClose={closeModal}
        buttonTestId="success-modal-btn"
      >
        {t('workplace_giving.myCampaigns.actions.publishSuccessModal.description')}
      </AcknowledgeModal>
    </Modal>
  )
}
